<template>
    <div class="ps-re">
<!--        公用部门树组件（不做新增和编辑功能）-->
        <el-select  v-if="isuseSearch" style="width: 100px"  class="usebutton" v-model="isuse" size="mini"  @change="refreshTree">
            <el-option v-for="item in isuseList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">
            </el-option>
        </el-select>
        <!--        <el-select @change="kqdataChange" style="width: 150px;margin-left: 20px;flex:1" size="mini" v-model="kqdata" slot="prepend" placeholder="请选择">-->
        <!--            <el-option v-for="val in kaoqinList" :key="val.i_id" :label='val.vc_tcname' :value="val.vc_tcname"></el-option>-->
        <!--        </el-select>-->
        <div class="tree gdheight mrt10 fitW" id="gdtree">
            <el-tree ref="tree" :data="treeData" lazy :key="treeId" :load="loadNode" :props="defaultProps"
                     node-key="wyid" @node-click="handleNodeClick" :default-expanded-keys="[0]"
                     class="trees  video-tree height100" accordion :highlight-current='true'
                     :expand-on-click-node="false" :show-checkbox="false">
            </el-tree>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {mapActions} from "vuex";
    import {baseerp, baseApp, file_url, baseVersion} from "@/utils/baseUrl";

    export default {
        name: "index",
        components: {},
        props:{
            isuseSearch:{//是否需要启用搜索
                type:Boolean,
                default:false,
            },
            withPerson:{//是否需要启用搜索
                type:Boolean,
                default:false,
            }
        },
        data() {
            return {
                defaultProps: {
                    children: 'children',
                    label: 'label',
                    isLeaf: 'isLeaf',
                    value:'i_id'
                },
                treeData:[],
                // kaoqinList:[],
                // kaoqini_id:0,
                // kqdata:'',
                isuse:1,
                isuseList:[{i_id:1,vc_name:this.$t('personInformation_enabled')},{i_id:0,vc_name:this.$t('personInformation_disabled')}],
                treeId:0,
                showMenuId:null,
                addMenu:'',
                editMenu:'',
                tableHeight:0,

            }
        },
        watch: {
            '$root.workSize': {
                handler(n, o) {
                    this.onResize(n);
                },
                deep: true,
            },
        },
        activated() {
            this.onResize();
        },
        mounted() {
            // this.getKqList()
            this.baseerp = baseerp;
            this.$nextTick(() => {
                this.onResize();
            })

        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),
            onResize(n) {
                if (n == undefined) n = this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight = n.h - (n.h) * 0.3+100;
                if (this.tableHeight < 60) this.tableHeight = 60;
            },
            refreshTree(){
                this.treeId=Math.random();
            },
            async getDeptTree({value=0,type='depart'},resolve){
                let param = {
                    i_mid: this.mid,
                    i_pid:value,
                    i_isuse:this.isuseSearch?this.isuse:1,
                    isiysuser:0,
                    withPerson:this.withPerson?1:0
                };
                let res = await API.getDeptTree(param);
                if (res.code == 1) {
                    let list=[];
                    if (res.data.length>0){
                        res.data.map(one=>{
                            let hash=one;
                            hash.isLeaf= this.withPerson?!one.hasSubPerson&&!one.hasSubDept:!one.hasSubDept;
                            hash.i_level= one.i_level;
                            hash.label= one.vc_name;
                            hash.value= one.i_id;
                            hash.i_state= one.i_state;
                            // hash.i_uid_auth=one.i_uid_auth;
                            hash.wyid= one.i_id+'_'+one.i_pid+'_'+one.nodeType;
                            list.push(hash);
                        })
                    }
                    return resolve(list);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            handleNodeClick(val){
                // console.log(val,'treeData')
                this.showMenuId=null;
                let data=JSON.parse(JSON.stringify(val));
                this.$emit('showData',data)
            },
            loadNode(node, resolve) {
                this.showMenuId=null;
                let _this=this;
                if (node.level === 0) {
                    let val={i_id:0,i_level:0,i_pid:0,label:this.$t('personInformation_all'),vc_name:this.$t('personInformation_all'),children:[],isLeaf:false};
                    return resolve([val]);
                }
                if (node.level>=1&&node.data.isLeaf==false){
                    _this.getDeptTree(node.data,resolve,node.level);
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    /deep/.el-tree-node__label{
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .ps-re{
        position: relative;

    }
    .fitW{
        width: fit-content;
    }
    .usebutton{
        position: absolute;
        right: 0;
        top: 0;
        z-index: 99;
    }
    /deep/ {
        .el-tree-node__label {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .el-tree-node__content{
            width: 100%;
        }
    }
    .menu{
        /*display: flex;*/
        border: 1px solid #8e8e8e;
        right: 0;
        position: absolute;
        background-color: #fff;
        box-shadow:0 2px 8px rgba(0,0,0,0.1);
    }
    .info{
        /*border: 1px solid #8e8e8e;*/
        padding: 5px 15px;
    }
    .info:hover{
        background-color: #CCCCCC;

    }
    .el-tree span{
        display: inline-block;
        width: 100%;
    }
</style>